<template>
  <div>
    <side-bar>
      <sidebar-link to="/shop">
        <md-icon>home_work</md-icon>
        Магазины
        <!-- <a v-on:click="resetPagination('/shop')">Магазины</a> -->
      </sidebar-link>
      <sidebar-link to="/registration">
        <md-icon>receipt</md-icon>
        Заявки
      </sidebar-link>
      <div @click="logout">
        <hr/>
        <sidebar-link to="#">
          <md-icon>exit_to_app</md-icon>
          Выход
        </sidebar-link>
      </div>
    </side-bar>
    <div class="main-panel">
      <div class="content">
        <dashboard-content></dashboard-content>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
/*.router-link-exact-active {*/
/*  background-color: cornflowerblue !important;*/
/*}*/

.md-list-item .router-link-exact-active a {
  text-transform: uppercase !important;
  font-style: inherit;
}
</style>
<script>
import DashboardContent from './Content.vue'
import {AUTH_LOGOUT} from '../../store/actions/auth'

export default {
  data () {
    return {}
  },
  components: {
    DashboardContent
  },
  methods: {
    logout () {
      this.$store
        .dispatch(AUTH_LOGOUT, {})
        .then(() => {
          this.$router.push({name: 'Dashboard'})
        })
        .catch(function (resp) {
        })
    },
    resetPagination (url) {
      this.$router.go('/shop')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue